import script from "./AddProgramMenuSections.vue?vue&type=script&setup=true&lang=js"
export * from "./AddProgramMenuSections.vue?vue&type=script&setup=true&lang=js"

import "./AddProgramMenuSections.vue?vue&type=style&index=0&id=65709fe2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65709fe2"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem});qInstall(script, 'directives', {ClosePopup});
